import { render, staticRenderFns } from "./Cooking-method-new.vue?vue&type=template&id=0de072ee&scoped=true&"
import script from "./Cooking-method-new.vue?vue&type=script&lang=js&"
export * from "./Cooking-method-new.vue?vue&type=script&lang=js&"
import style0 from "./Cooking-method-new.vue?vue&type=style&index=0&id=0de072ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0de072ee",
  null
  
)

export default component.exports